




























































































import { Vue, Prop, Component } from 'vue-property-decorator';
import DatePicker from '../components/DatePicker.vue';
import restService from '../services/restService';

@Component({
  components: {
    // DatePicker,
  }
})
export default class AddUser extends Vue {
  dialog = false;
  formValid = false;
  user: IUser | null = null;
  rules = {
    required: (value: string) => !!value || 'Tämä on pakollinen kenttä',
    counter: (value: string) => value.length <= 20 || 'Max 20 characters',
    email: (value: string) => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || '';
    }
  };

  formData: IUser = {
    id: '',
    name: '',
    userName: '',
    email: '',
    isCompany: false,
    note: '',
    adminNote: '',
    address: '',
    postalcode: '',
    city: '',
    phoneNumber: ''
  };

  @Prop({ default: false }) private text!: boolean;
  @Prop({ default: false }) private outlined!: boolean;

  // startDate = new Date().toISOString().substr(0, 10);
  // endDate = new Date(new Date().getFullYear(), 1, 1)
  //   .toISOString()
  //   .substr(0, 10);

  get showBankingInformation() {
    return !this.$store.state.app.shareHasMembers;
  }

   get shareHasMembers() {
    return this.$store.getters['app/shareHasMembers'];
  }

  async sendPost() {
    this.user = await restService.users.postCreateNewUser(this.formData);
    this.$store.commit('admin/addUser', this.user);
    this.$emit('input', this.user);
    this.dialog = false;
  }
}
